<template>
  <section class="main-box">
    <!--工具条-->
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" :model="filters" ref="param">
          <el-form-item label="项目">
            <ProjectList @proSelected="proChange"></ProjectList>
          </el-form-item>
          <el-form-item>
            <el-input v-model="filters.searchTab" placeholder="按标题搜索" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="doSearch()">查询</el-button>
            <el-button v-on:click="showAddView()" type="success">添加</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <!--列表-->
    <template>
      <el-table :data="data" highlight-current-row v-loading="loading">
        <el-table-column type="index" label="序号" width="100" align="center">
        </el-table-column>
        <el-table-column prop="mesTitle" label="标题" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" :formatter="formatDate">
        </el-table-column>
        <el-table-column label="操作" width="251" align="center">
          <template slot-scope="scope">
            <el-button size="small" @click="openDetails(scope.$index, scope.row)">查看</el-button>
            <el-button size="small" @click="showEditView(scope.$index, scope.row)">编辑</el-button>
            <el-button type="danger" size="small" @click="doDel(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="prev, pager, next" @current-change="searchPage" :page-size="limit" :total="total"
                       class="layout-right">
        </el-pagination>
      </el-col>
    </template>
    <!-- 表单视图 -->
    <el-dialog title="编辑动态" :visible.sync="formVisible" :close-on-click-modal="false" :modal="false" width="80%">
      <div v-if="formVisible">
        <MessageForm :option="option" @doSubmit="doSubmit" @doCancel="doCancel" :form-obj="formData" ></MessageForm>
      </div>
    </el-dialog>
    <!-- 详情界面 -->
    <el-dialog :title="formData.mesTitle" :visible.sync="detailsVisible" :modal="false" class="details" :close-on-click-modal="false">
      <MessageView :mes="formData.mesContent"></MessageView>
    </el-dialog>
  </section>
</template>
<script>
  import { mesDel, mesSearch, mesDetail,proSearch} from '../../api/api'
  import MessageForm from "./MessageForm";
  import "../../../static/ueditor/ueditor.config.js";
  import "../../../static/ueditor/ueditor.all.js";
  import "../../../static/ueditor/lang/zh-cn/zh-cn.js";
  import "../../../static/ueditor/ueditor.parse.js";
  import MessageView from "./MessageView";
  import ProjectList from "../command/ProjectList";

  export default {
    components: {ProjectList, MessageView, MessageForm},
    data() {
      return {
        proId:null,
        filters: {},
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        loading: false,
        total: 2,
        page: 1,
        limit: 15,
        data: [],
        formData: {},
        encType: 5,
        formVisible: false,
        detailId: null,
        option:0,
        detailsVisible: false,
        proList:[],
      }
    },
    methods: {
      //查询
      searchData: function () {
        this.GLOBAL.checkRole(this.GLOBAL.fun.projectMes, this.GLOBAL.option.select, this);
        this.loading = true;
        this.filters.page = this.page;
        this.filters.limit = this.limit;//请求参数
        if (this.filters.searchTab == '') {
          this.filters.searchTab = null;
        }
        this.filters.proId = this.proId == '' ? null : this.proId;
        this.filters.comId = this.GLOBAL.user.comId;
        mesSearch(this.filters, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.data = result.data.result;
            this.total = result.data.total;

            this.loading = false;
          }
        });
      },
      doSearch: function () {
        this.searchData()
      },
      resetForm: function () {
        this.filters = {}
      },
      searchPage: function (val) {
        this.page = val;
        this.searchData();
      },
      formatDate: function (row, column) {
        return this.GLOBAL.formatTimeToStr(row.createTime, "yyyy-MM-dd hh:mm:ss");
      },
      //========================================
      //添加视图
      showAddView: function () {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.projectMes, this.GLOBAL.option.create, this);
        if (res) {
          this.option = 0;
          this.formData = {proId:null,mesTitle:null,mesContent:null}
          this.formVisible = true;
        }
      },
      //编辑视图
      showEditView: function (index, row) {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.projectMes, this.GLOBAL.option.update, this);
        if (res) {
          this.option = 1;
          this.detailId = row.id;
          mesDetail({id: row.id}, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.formData = result.data;
              this.formVisible = true;
            }
          });
        }
      },
      //表单提交后回调
      doSubmit: function () {
        this.searchData();
        // UE.getEditor('editor').destroy();
        this.formVisible = false;

      },
      //表单取消后回调
      doCancel: function () {
        // UE.getEditor('editor').destroy();
        this.formVisible = false;
      },
      //删除
      doDel: function (index, row) {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.projectMes, this.GLOBAL.option.delete, this);
        if (res) {
          this.$confirm('确认删除该记录吗?', '提示', {
            type: 'warning'
          }).then(() => {
            mesDel({id: row.id}, this.GLOBAL.header).then(result => {
              if (result.success) {
                this.$message({
                  message: "删除成功",
                  type: 'success'
                });
                this.searchData();
              }
            });
          }).catch(() => {
          });
        }
      },
      //查看详情
      openDetails: function (index, row) {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.projectMes, this.GLOBAL.option.message, this);
        if (res) {
          mesDetail({id: row.id}, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.formData = result.data;
              this.detailsVisible = true;
            }
          });
        }
      },
      proChange:function(proId){
        this.proId = proId;
        this.doSearch();
      }
    },
    mounted() {

    }
  };
</script>
<style scoped>
  .download {
    text-decoration: none;
    color: blue;
  }
</style>



// WEBPACK FOOTER //
// src/components/message/Message.vue